import {View} from 'MWC';
import React from 'react';
import tpl from '../templates/TooltipNew.jsx';
import {canUseDOM} from '../../../../helpers/canUseDOM.js';

const VIEWPORT_MARGIN = 16;

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            popupOffsetX: 0
        };
        this.popupRef = React.createRef();
        this.wrapperRef = React.createRef();
        this.canHover = canUseDOM && window.matchMedia('(hover: hover)').matches;
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        return this;
    }

    componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
    }

    adjustOffset() {
        if (!this.popupRef.current) return;
        const rect = this.popupRef.current.getBoundingClientRect();
        let offset = 0;
        if (rect.right > window.innerWidth - VIEWPORT_MARGIN) {
            offset = window.innerWidth - VIEWPORT_MARGIN - rect.right;
        } else if (rect.left < VIEWPORT_MARGIN) {
            offset = VIEWPORT_MARGIN - rect.left;
        }
        if (offset !== 0) {
            this.setState({popupOffsetX: offset});
        }
    }

    handleMouseEnter() {
        if (!this.canHover) return;
        this.setState({visible: true, popupOffsetX: 0}, () => {
            this.adjustOffset();
        });
    }

    handleMouseLeave() {
        if (!this.canHover) return;
        this.setState({visible: false, popupOffsetX: 0});
    }

    handleClick() {
        if (this.canHover) return;
        const next = !this.state.visible;
        this.setState({visible: next, popupOffsetX: 0}, () => {
            if (next) this.adjustOffset();
        });
    }

    handleOutsideClick(e) {
        if (this.wrapperRef.current && this.wrapperRef.current.contains(e.target)) return;
        if (this.state.visible) {
            this.setState({visible: false, popupOffsetX: 0});
        }
    }
}
